import React, { useMemo } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { WinPopUp } from '../winPopUp';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';

export function MobileWinPopUp({ winningAmount, currencyCode, winCombination }) {
  const winningCombination = useMemo(() => {
    return COMBINATIONS_PAYOUTS.find((item) => item.winType === winCombination);
  }, [winCombination]);
  const t = useTranslation();

  return (
    <div className='mobile-popup-wrapper'>
      <div className='tb-g-mob-comb-row'>
        <div className='tb-g-mob-comb-row-item active'>
          <p className='tb-g-mob-comb-row-name'>{t(winningCombination.type)}</p>
          <p className='tb-g-mob-comb-row-coef'>x{winningCombination.odd}</p>
        </div>
      </div>
      <WinPopUp winningAmount={winningAmount} currencyCode={currencyCode} />
    </div>
  );
}
